import { createSelector } from 'reselect';
import { List, Set as ImmutableSet } from 'immutable';
import { initialState } from '../reducers/scenario.reducer';
import { SCENARIOS } from '../constants/scenario.constants';

const selectState = state => state[SCENARIOS] || initialState;

// Merge V3 + V4; V3 wins on collision (still receives WS updates).
export const selectScenarios = () => createSelector(selectState, state => {
	const v3Scenarios = state.get('data').toList().filter(s => !!s);
	const v4Scenarios = state.get('v4Scenarios') || List();
	if (!v4Scenarios.size) return v3Scenarios;

	const dedupUuids = state.get('dedupV4Uuids') || ImmutableSet();
	const existingIds = new Set();
	v3Scenarios.forEach(s => { if (s?.id != null) existingIds.add(String(s.id)); });

	const additions = v4Scenarios.filter(s => {
		if (!s) return false;
		const id = s.get ? s.get('id') : s.id;
		if (id == null) return false;
		if (dedupUuids.has(String(id))) return false;
		return !existingIds.has(String(id));
	});
	return v3Scenarios.concat(additions);
});
// V4-only scenarios (their ids are the uuids V4 configs reference). V4 DevCon
// supports only these — do NOT mix in V3 scenarios.
export const selectV4Scenarios = () =>
	createSelector(selectState, state => state.get('v4Scenarios') || List());
// Whether the V4 list has been loaded at all (it can legitimately be empty).
export const selectV4ScenariosFetched = () =>
	createSelector(selectState, state => !!state.get('v4Fetched'));
export const selectScenariosFetched = () => createSelector(selectState, state => state.get('fetched'));
export const selectSelectedScenario = () => createSelector(selectState, state => state.get('selectedScenario'));